import { API_URL, setHeader } from 'api';
import axios from 'axios';

const URL = `${API_URL}/reports`;

export const runArchivedReport = params => {
  const req = setHeader(axios);
  return req.get(`${URL}/archived-questions`, { params });
};

export const runPrescreenReport = params => {
  const req = setHeader(axios);
  return req.get(`${URL}/prescreen`, { params });
};

export const runAssessmentByQuestionTypeReport = params => {
  const req = setHeader(axios);
  return req.get(`${URL}/question-type`, { params });
};

export const runCertificateOnFileReport = params => {
  const req = setHeader(axios);
  return req.get(`${URL}/certificate-on-file`, { params });
};

export const runConditionalApprovalCommentsReport = params => {
  const req = setHeader(axios);
  return req.get(`${URL}/conditional-approvals`, { params });
};

export const runIndividualRequestReport = params => {
  const req = setHeader(axios);
  return req.get(`${URL}/individual`, { params });
};

export const runOutstandingAssessmentsReport = params => {
  const req = setHeader(axios);
  return req.get(`${URL}/outstanding-assessments`, { params });
};

export const runPendingRenewalsReport = params => {
  const req = setHeader(axios);
  return req.get(`${URL}/renewals`, { params });
};
